<template>
    <div id="homeBox">
        <div style="display: flex;justify-content: space-between;height: 40px">
            <div style="display:flex;align-items: center">
                <div style="margin-right: 15px;margin-left: 20px;">
                    <el-button size="mini" type="text" @click="chongzhi">用户充值</el-button>
                </div>
                <div style="position: relative">
                    <input type="file" name="files" value="" id="uploadfile"
                           ref="uploadclear1"    class="upload-input uploadfile1" @change="upload"  >
                    <el-button  type="text" size="mini" icon="el-icon-upload">餐补批量充值</el-button>
                </div>
            </div>
            <div style="display:flex;align-items: center;margin-right: 20px">
<!--                <div style="margin: 0 15px">-->
<!--                    <el-select  size="mini" v-model="companydata" slot="prepend" placeholder="请选择">-->
<!--                        <el-option v-for="val in companyList" :key="val.id" :label='val.name' :value="val.name"></el-option>-->
<!--                    </el-select>-->
<!--                </div>-->
                <div>
                    <el-input
                            size="mini"
                            class="input"
                            placeholder="请输入搜索内容"
                            v-model="search"
                            clearable>
                    </el-input>

                </div>
                <el-button style="margin-left: 10px" class="mrl15 " icon="el-icon-search" circle  @click="searchall" size="mini"></el-button>

            </div>
        </div>


        <el-table
                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip>
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="code"-->
<!--                    label="订单编号"-->
<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="typeName"
                    label="充值类型"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="moneyTotal"
                    label="金额(元)"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="note"
                    :label="$t('form_notes')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    label="录入人"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="录入时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    label="操作"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="seebalance(scope.row)">余额明细查看</el-button>

                </template>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl" style="display: flex;justify-content: space-between">
                    <el-pagination
                            small

                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 50, 100, 400]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
                :close-on-click-modal="false"

                title="用户充值"
                :visible.sync="delDialogVisible"
                width="480px"
                v-if="delDialogVisible"
        >
            <add-balance :editData="editData" @closedialog="closedialog" @savesuccess="savesuccess"></add-balance>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"

                :title="title"
                :visible.sync="detaildialog"
                width="50%"
                v-if="detaildialog"
        >
            <balance-detail :editData="editData" @closedialog="closedialog" @savesuccess="savesuccess"></balance-detail>
        </el-dialog>
        <!--审批dialog-->
        <div >
            <el-dialog

                    class="dia"
                    width="30%"
                    title="文件上传"
                    :visible.sync="checkdialogVisible"
                    :close-on-click-modal="false"
                    v-loading="loading"
                    @close="guanbi"
                    element-loading-text="正在提交中..."
                    v-if="checkdialogVisible">
                <p id="loading1">{{diatext}}</p>
                <div style="text-align: right; margin: 0">
                    <!--                    <el-button size="mini"   @click="checkdialogVisible = false">取消</el-button>-->
                    <el-button type="primary"  size="mini" @click="guanbi">关闭</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import addBalance from "./component/addBalance";
    import balanceDetail from "./component/balanceDetail";
    import {baseerp,baseApp,baseVersion} from "@/utils/baseUrl";

    import * as API from "./api";
    export default{
        name:'mealCardManage',
        components:{
            addBalance,
            balanceDetail
        },
        data(){
            return{
                diatitle:'',
                checkdialogVisible:false,
                loading:false,
                delDialogVisible:false,
                tableHeight:'auto',
                pageSize:10,
                currentPage:1,
                search:"",
                tableData:[],
                detaildialog:false,
                total:0,
                editData:{},
                title:'',
                mid:''
            }
        },

        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        created(){
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        mounted(){
            this.getList()
        },

        methods:{

            seebalance(e){
                this.title='用户余额变动明细'
                this.editData=e
                this.detaildialog=true
            },
            searchall(){
                this.currentPage=1
                this.tableData=[]
                this.getList()
            },
            savesuccess(){
                this.currentPage=1
                this.tableData=[]
                this.getList()
              this.delDialogVisible=false
            },
            guanbi(){
                this.checkdialogVisible=false
                this.currentPage=1
                this.tableData=[]
                this.getList()
            },
            //接口文件上传
            async upload(value){
                this.diatext='文件正在上传'
                this.checkdialogVisible=true

                let $files = value.target.files[0];

                let files=$files
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                var uploaddata={
                    'version':baseVersion,
                    "app":baseApp,
                    "token":sessionStorage.getItem("token"),
                    "i_uid": sessionStorage.getItem("userid"),
                    "vc_lruname":  sessionStorage.getItem("lruname"),
                    "i_lruid": sessionStorage.getItem("userid"),
                    "i_mid": this.mid,
                    "userId":sessionStorage.getItem("userid"),
                    "userName":sessionStorage.getItem("lruname"),
                }
                var data1 =JSON.stringify(uploaddata)
                var params={
                    "file":files,
                    "data":data1
                }

                let FD = new FormData();
                for (let key in params) {
                    FD.append(key, params[key])
                }
                // if(params.files.type!=='application/vnd.ms-excel'){
                //     this.$message.error('请选择.xls文件进行上传')
                //     document.getElementById('uploadfile').outerHTML = document.getElementById('uploadfile').outerHTML
                //     document.getElementById('uploadfile').addEventListener('change', this.upload)
                //     // value=''
                //     // loading.close()
                //     return
                // }
                let res=await API.importRecharge(params)
                if(res.code==1){
                    this.diatext=res.message
                    this.$forceUpdate()
                    this.loading=false


                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    document.getElementById('uploadfile').outerHTML = document.getElementById('uploadfile').outerHTML
                    document.getElementById('uploadfile').addEventListener('change', this.upload)

                } else if (res.code == -2) {
                    this.diatext=res.message
                    this.loading=false

                    this.$router.push('/login')
                    document.getElementById('uploadfile').outerHTML = document.getElementById('uploadfile').outerHTML
                    document.getElementById('uploadfile').addEventListener('change', this.upload)
                    this.$message.error(res.message);
                }else{
                    this.diatext=res.message
                    this.loading=false

                    document.getElementById('uploadfile').outerHTML = document.getElementById('uploadfile').outerHTML
                    document.getElementById('uploadfile').addEventListener('change', this.upload)
                    this.$message.error(res.message);
                };
            },
            chongzhi(){
                this.editData={
                    uName:'',
                    id:0,
                    moneyTotal:0,
                    note:'',
                    type:''
                }
                this.delDialogVisible=true
            },
            closedialog(){
              this.delDialogVisible=false
                this.detaildialog=false


            },

            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },

            //分页
            handleSizeChange(val) {
                this.pageSize = val;    //动态改变
                this.getList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.getList()
            },
            async getList(val){
                let param = {
                   pageSize:this.pageSize,
                    currentPage:this.currentPage,
                    uName:this.search
                };
                let res = await API.getList(param);
                if (res.code == 1) {
                    this.tableData=res.data
                    this.total=res.total
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        },
    }

</script>
<style lang="scss" scoped>

    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        top: -3px;
        left: 6px;
        width: 100px;
        height: 80px;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width:610px !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
</style>